const LatestMusicVideosStatic = () => {
    return (
      <>
        <div class="music-video">

        <div class="music-video">
            <div class="music-video-container">
                <iframe src="https://www.youtube.com/embed/fFDR1wDZPXI" title="test" allowfullscreen></iframe>
                </div>
                <p><strong>Kawaii Ry & Meauxminy</strong><br/>Sometimes</p>  
            </div>

        </div>
      </>
    );
  };
  export default LatestMusicVideosStatic;